// /premium (design_handoff_premium, 2026-09-05) + /channels/[id] redesign copy.
export const premium: Record<string, string> = {
  'VIP groups': 'VIP grupe',
  'Signals from traders with a public track record.': 'Signali od trejdera sa javnim rezultatom.',
  'Every group is run by a trader whose signals are settled by the market on ShowMeTrade. Check the score and the closed trades before you subscribe. Monthly, cancel any time.':
    'Svaku grupu vodi trejder čije signale na ShowMeTrade zatvara tržište. Pogledaj skor i zatvorene trejdove pre nego što se pretplatiš. Mesečno, otkazivanje bilo kad.',
  'Entry, stop and target are locked at publish time — nobody edits them afterwards.': 'Ulaz, stop i cilj su zaključani u trenutku objave — niko ih ne menja posle.',
  'The market closes the trade, not the trader. The 0–100 score is public on the profile.': 'Trejd zatvara tržište, ne trejder. Skor 0–100 je javan na profilu.',
  'Payment via Stripe. Cancel with one click, no questions.': 'Plaćanje preko Stripe-a. Otkaži jednim klikom, bez pitanja.',
  'Featured': 'Istaknuto',
  'MT5 live account': 'MT5 live nalog',
  'Return since start': 'Prinos od početka',
  'Equity': 'Equity',
  'Floating P/L': 'Floating P/L',
  'Open positions': 'Otvorene pozicije',
  'Loading MT5 data…': 'Učitavam podatke sa MT5…',
  '/ mo.': '/ mes.',
  'Open channel →': 'Otvori kanal →',
  'All VIP groups': 'Sve VIP grupe',
  'The score is public — click the trader and check the track record.': 'Skor je javan — klikni na trejdera i proveri track record.',
  '/mo': '/mes',
  'members': 'članova',
  'New group': 'Nova grupa',
  'View →': 'Pogledaj →',
  'No description.': 'Bez opisa.',
  'Locked signal': 'Zaključan signal',
  'Every signal in a group has an entry, stop and target locked at publish time.': 'Svaki signal u grupi ima ulaz, stop i cilj zaključane u trenutku objave.',
  'The market closes it': 'Zatvara ga tržište',
  'The public score and closed trades are on the trader’s profile — look before you pay.': 'Javni skor i zatvoreni trejdovi su na profilu trejdera — pogledaj pre nego što platiš.',
  'Monthly, no commitment': 'Mesečno, bez obaveza',
  'Payment via Stripe, monthly, cancel any time.': 'Plaćanje preko Stripe-a, mesečno, otkazivanje bilo kad.',
  'Trading carries risk; nothing here is investment advice.': 'Trgovanje nosi rizik; ništa ovde nije investicioni savet.',
  'No VIP groups yet.': 'Još nema VIP grupa.',
  // channel page
  '← All VIP groups': '← Sve VIP grupe',
  'Score': 'Skor',
  'ShowMeTrade signals': 'ShowMeTrade signali',
  'Equity, last 24 h': 'Equity, poslednja 24 h',
  'Start': 'Start',
  'Updated': 'Ažurirano',
  'data straight from MT5': 'podaci direktno sa MT5',
  'Closed signals': 'Zatvorenih signala',
  'Win rate': 'Win rate',
  'W / L / BE': 'W / L / BE',
  'About the group': 'O grupi',
  'Last closed trades': 'Poslednji zatvoreni trejdovi',
  'Full track record →': 'Ceo track record →',
  'Date': 'Datum',
  'Side': 'Smer',
  'Entry': 'Ulaz',
  'Exit': 'Izlaz',
  'Result': 'Rezultat',
  'No closed trades yet.': 'Još nema zatvorenih trejdova.',
  'VIP channel': 'VIP kanal',
  'channel': 'kanal',
  'Every entry from this account — SL, TP and the reasoning, in real time.': 'Svaki ulaz sa ovog naloga — SL, TP i obrazloženje, u realnom vremenu.',
  '/ monthly': '/ mesečno',
  'Signals in real time, with SL and TP': 'Signali u realnom vremenu, sa SL i TP',
  'Reasoning with every entry': 'Obrazloženje uz svaki ulaz',
  'Access to the history of all closed trades': 'Pristup istoriji svih zatvorenih trejdova',
  'Cancel any time': 'Otkazivanje bilo kad',
  'Join the channel →': 'Pridruži se kanalu →',
  'Secure payment via Stripe · monthly · cancel any time': 'Sigurno plaćanje preko Stripe-a · mesečno · otkazivanje bilo kad',
  'Free channel': 'Besplatan kanal',
  'Subscribe free →': 'Pretplati se besplatno →',
  'Redirecting…': 'Preusmeravam…',
  'You are a member': 'Član si',
  'Member since': 'Član od',
  'Renews': 'Obnavlja se',
  'Access until': 'Pristup do',
  'Cancel subscription': 'Otkaži pretplatu',
  'Manage billing': 'Upravljaj naplatom',
  'Resubscribe →': 'Pretplati se ponovo →',
  'Your channel': 'Tvoj kanal',
  'Dashboard': 'Kontrolna tabla',
  'New post': 'Nova objava',
  'Edit channel': 'Izmeni kanal',
  'Signals': 'Signali',
  'Posts': 'Objave',
  // shared shell + real MT5 stats (2026-09-06)
  'VIP GROUPS': 'VIP GRUPE',
  'WHY VIP GROUPS': 'ZAŠTO VIP GRUPE',
  'Entry, stop and target are locked at publish time. The market closes the trade, not the trader — the 0–100 score is public. Stripe, monthly, cancel any time.':
    'Ulaz, stop i cilj su zaključani u trenutku objave. Trejd zatvara tržište, ne trejder — skor 0–100 je javan. Stripe, mesečno, otkazivanje bilo kad.',
  'Semafor (MT5 live)': 'Semafor (MT5 uživo)',
  'Monthly, cancel any time.': 'Mesečno, otkazivanje bilo kad.',
  'Net result': 'Neto rezultat',
  'Return (TWR)': 'Prinos (TWR)',
  'Trades': 'Trejdova',
  'Closed P/L since the account started': 'Zatvoreni P/L od početka naloga',
  'MT5 data unavailable': 'MT5 podaci nedostupni',
  'Result since start': 'Rezultat od početka',
  'Closed P/L, since': 'Zatvoreni P/L, od',
  'Profit factor': 'Profit faktor',
  'Max drawdown': 'Max. pad (DD)',
  'Closed trades': 'Zatvorenih trejdova',
  'Lot': 'Lot',
  'Time-weighted return: deposits and withdrawals do not affect it. Net result = closed P/L + floating.': 'Vremenski ponderisan prinos: uplate i isplate ne utiču na njega. Neto rezultat = zatvoreni P/L + floating.',
  'Start balance': 'Početni balans',
  'withdrawn': 'isplaćeno',
  'MARKET CLOSED': 'TRŽIŠTE ZATVORENO',
  'deposited': 'uplaćeno',
  'connected account (read-only)': 'povezan nalog (read-only)',
  'Return': 'Prinos',
  'Balance': 'Balans',
  'Source': 'Izvor',
  'Results of the linked account are visible only to you — turn on public display in channel settings.': 'Rezultati povezanog naloga vidljivi su samo tebi — uključi javni prikaz u podešavanjima kanala.',
};
